module.exports = __webpack_public_path__ + "44a6e8a02ac0997c560808165f8d1281.png";